import React, { useEffect, useState } from 'react';
import './courseKit.css';

const pad = (n) => String(n).padStart(2, '0');

const remaining = (endsAt) => {
  const ms = new Date(endsAt).getTime() - Date.now();
  if (!Number.isFinite(ms) || ms <= 0) return null;
  return {
    days: Math.floor(ms / 86400000),
    hours: Math.floor((ms % 86400000) / 3600000),
    minutes: Math.floor((ms % 3600000) / 60000),
    seconds: Math.floor((ms % 60000) / 1000),
  };
};

/**
 * Live countdown to a REAL promotion deadline from the promotions table.
 * Renders nothing once the deadline passes, so an expired sale can never keep
 * showing a fake timer.
 */
const PromoCountdown = ({ endsAt, label }) => {
  const [left, setLeft] = useState(() => remaining(endsAt));

  useEffect(() => {
    if (!endsAt) return undefined;
    setLeft(remaining(endsAt));
    const id = setInterval(() => {
      const next = remaining(endsAt);
      setLeft(next);
      if (!next) clearInterval(id);
    }, 1000);
    return () => clearInterval(id);
  }, [endsAt]);

  if (!endsAt || !left) return null;

  return (
    <div className="ck-countdown" role="timer" aria-live="off">
      {label ? <span className="ck-countdown-label">{label}</span> : null}
      <span className="ck-countdown-clock">
        {left.days > 0 ? <b>{left.days}d </b> : null}
        <b>{pad(left.hours)}</b>:<b>{pad(left.minutes)}</b>:<b>{pad(left.seconds)}</b>
      </span>
    </div>
  );
};

export default PromoCountdown;
